<template>
  <div>
    <LayoutHeader
      activeNav="首页"
      :topColor="topColor"
      bannerType="header index"
      :height="380"
    />

    <div style="display: none">
      <img
        v-for="(item, index) in 60"
        width="50"
        height="50"
        :key="index"
        :id="'img_' + item"
        :src="'/avatar/' + item + '.jpg'"
      />
    </div>

    <!-- login -->
    <div class="login" v-show="admin_token == null || admin_token == ''">
      <a-divider>身份验证</a-divider>
      <div class="form">
        <a-form-model
          :model="form_login"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 14 }"
          size="small"
        >
          <a-form-model-item label="登录方式">
            <a-radio-group v-model="form_login.type" button-style="solid">
              <!-- <a-radio-button :value="0">管理员</a-radio-button> -->
              <a-radio-button :value="1">组委会</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="组委会代码" v-if="form_login.type == 1">
            <a-input
              v-model="form_login.oc_code"
              placeholder="请输入组委会代码"
            />
          </a-form-model-item>
          <a-form-model-item label="登录账号">
            <a-input v-model="form_login.account" placeholder="请输入账号" />
          </a-form-model-item>
          <a-form-model-item label="登录密码">
            <a-input
              v-model="form_login.password"
              type="password"
              placeholder="请输入密码"
            />
          </a-form-model-item>

          <a-form-model-item label="">
            <div style="text-align: center">
              <a-button type="primary" @click="subLoginAdmin">登录</a-button>
            </div>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
    <!-- 选择赛事 -->
    <div
      class="login"
      v-show="admin_token != null && admin_token != '' && type == 1"
    >
      <a-divider>选择赛事</a-divider>
      <div class="form">
        <a-form-model
          :model="matchList"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 14 }"
          size="small"
        >
          <a-form-model-item label="选择赛事">
            <a-select
              placeholder="请选择"
              style="width: 300px"
              @change="getMatchId"
            >
              <a-select-option
                v-for="(art_item, art_index) in matchList"
                :key="art_index"
                :value="art_item.id"
              >
                {{ art_item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="">
            <div style="text-align: center">
              <a-button type="primary" @click="useMatch()">选择</a-button>
            </div>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
    <!-- login -->

    <div
      class="container"
      v-show="admin_token != null && admin_token != '' && type == 2"
    >
      <div class="repeatTitle">
        <div class="title_text art_info_line">
          <h1>专家抽取</h1>
          <h2>Select Expert</h2>
        </div>
      </div>

      <div class="select_choose">
        <!-- <div class="left" v-if="!showImg">
          <h1
            style="
              font-size: 20px;
              text-align: center;
              margin-bottom: 20px;
              margin-top: 20px;
            "
          >
            ——&nbsp;&nbsp;&nbsp;抽取&nbsp;&nbsp;&nbsp;——
          </h1>
          <vue-seamless-scroll
            :data="listData"
            :class-option="classOption"
            class="seamless-warp"
          >
            <ul class="item">
              <li
                v-for="(item, index) in listData"
                :key="index"
                class="expert_item"
              >
                <img
                  style="
                    width: 52px;
                    height: 52px;
                    border-radius: 50%;
                    margin-right: 20px;
                  "
                  :src="item.img"
                  alt=""
                />
                <div class="name" v-text="item.name"></div>
                <div class="phone" v-text="item.phone"></div>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>

        <div class="left" v-else>
          <img
            style="width: 320px; height: 400px"
            src="../../assets/images/default/mh@2x.png"
            alt=""
          />
        </div> -->

        <!-- <div class="left" style="border:0px;"></div> -->
        <div class="right" style="margin: 0px auto">
          <a-form :form="form">
            <div v-if="!hasSelected && !showImg">
              <a-form-item label="艺术门类">
                <a-select
                  placeholder="请选择"
                  style="width: 300px"
                  v-decorator="['artValue']"
                >
                  <a-select-option
                    v-for="(art_item, art_index) in artOptions"
                    :key="art_index"
                    :value="art_item.id"
                  >
                    {{ art_item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="地区选择">
                <a-cascader
                  style="width: 300px"
                  v-decorator="['addressValue']"
                  :options="areaOptions"
                  :load-data="loadArea"
                  placeholder="请选择"
                  change-on-select
                />
              </a-form-item>

              <!-- <a-form-item label="行业类型">
                <a-select
                  placeholder="请选择"
                  style="width: 300px"
                  v-decorator="['cate_id']"
                >
                  <a-select-option
                    v-for="(art_item, art_index) in cateOptions"
                    :key="art_index"
                    :value="art_item.id"
                  >
                    {{ art_item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item> -->

              <a-form-item label="抽取人数">
                <a-select
                  placeholder="请选择"
                  style="width: 300px"
                  v-decorator="['limit']"
                >
                  <a-select-option
                    v-for="(art_item, art_index) in 10"
                    :key="art_index"
                    :value="art_index"
                  >
                    {{ art_item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <a-form-item>
              <scrollExpert
                v-if="hasSelected"
                class=""
                :dataList="expertList"
              ></scrollExpert>
              <!-- <canvas  v-if="hasSelected" class="random-dom" id="random_avatar" :width="random_config.main_width" :height="random_config.main_height"></canvas> -->
            </a-form-item>

            <div class="btns">
              <div @click="reset">重置</div>
              <div
                v-if="expertList.length !== 0 && showImg"
                style="margin-left: 20px"
                @click="exportData()"
              >
                导出
              </div>
              <div v-if="!hasSelected && !showImg" class="start" @click="start">
                开始抽取
              </div>
              <div v-else-if="!showImg" @click="stop" class="end">暂停</div>
            </div>
          </a-form>
        </div>
      </div>

      <div v-if="expertList.length !== 0 && showImg" class="top">
        <div>抽取结果</div>
      </div>

      <ul v-if="expertList.length !== 0 && showImg" class="experts">
        <li
          v-for="(expert_item, expert_index) in expertList"
          :key="expert_index"
          @click="goExpertDetail(expert_item)"
        >
          <img
            v-if="expert_item.img_avatar_full"
            :src="expert_item.img_avatar_full"
            alt=""
          />
          <img
            v-else
            src="../../assets/images/user/yh-icon-touxiang@2x.png"
            alt=""
          />
          <div>姓名: {{ expert_item.name }}</div>
          <div>艺术门类: {{ expert_item.art_category_name[0] }}</div>
          <div>联系方式: {{ expert_item.mobile }}</div>
        </li>
      </ul>

      <LayoutNoData
        v-if="expertList.length == 0 && showImg"
        style="margin-top: 50px"
      />
    </div>

    <LayoutFooter />
  </div>
</template>

<script>
import SystemServices from "../../xx-vue/services/system";
import ExpertServices from "../../xx-vue/services/expert";

import { createCanvas } from "@/xx-vue/libs/randomAvatar";

import scrollExpert from "@/components/scrollExpert/index.vue";

import { loginAdmin, getMatch,exportData } from "../../xx-vue/services/system";

export default {
  components: {
    scrollExpert,
  },
  data() {
    return {
      topColor: "background-color: rgba(0, 0, 0, 0.3)",
      listData: [
        // {
        //   img: require("../../assets/images/static_expert/TX_01.png"),
        //   name: "林静",
        //   phone: "151****5859",
        // },
      ],
      artOptions: [],
      areaOptions: [],
      cateOptions: [],
      expertList: [],
      hasSelected: false,
      showImg: false,
      step: 0,

      search_num: 0,
      random_config: {
        main_width: 800,
        main_height: 500,
      },

      admin_token: null,
      form_login: {
        type: 1, // 0管理员，1组委会
        oc_code: "",
        account: "",
        password: "",
      },
      matchList: [], //赛事列表
      type: 1,
      matchId: "", //赛事id
      oc_id: "",
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "selectForm" });
  },
  computed: {
    classOption() {
      return {
        direction: 0,
        hoverStop: false,
        step: this.step,
      };
    },
  },
  mounted() {
    this.initScroll();
    this.initData();
    this.form.setFieldsValue({ limit: 0 });
    //获取赛事
    // this.getMatch();
  },

  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    subLoginAdmin() {
      loginAdmin(this.form_login).then((api_res) => {
        if (api_res.code == 200) {
          var token = api_res.data.token;
          this.admin_token = token;
          this.oc_id = api_res.data.info.oc_id;
          this.getMatch(api_res.data.info.id); //获取赛事列表
        }
      });
    },
    goExpertDetail(item) {
      this.$router.push("/user/visit?expert_id=" + item.id);
    },
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //初始化下拉框
    async initData() {
      const nation_place = await SystemServices.getAreaAsync();
      let artOptions = await SystemServices.getArtAsync({ pid: 0 });
      this.artOptions = artOptions.data.data;

      this.areaOptions = nation_place.data.list.map((v) => {
        return { ...v, value: v.id, label: v.name, isLeaf: !v.hasChildren };
      });

      const cateOptions = await SystemServices.getIndustryAsync();
      this.cateOptions = cateOptions.data.data;
    },
    //懒加载区域
    loadArea(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      const pid = targetOption.id;
      targetOption.loading = true;
      // 懒加载请求
      setTimeout(async () => {
        targetOption.loading = false;
        let result = await SystemServices.getAreaAsync({ pid: pid });
        // console.log(targetOption);
        let data = result.data.list;
        const isLeaf = targetOption.level < 2 ? false : true;
        data = data.map((v) => {
          return {
            ...v,
            value: v.id,
            label: v.name,
            isLeaf: isLeaf,
          };
        });
        targetOption.children = data;
        this.areaOptions = [...this.areaOptions];
      }, 100);
    },
    //开始抽取
    start() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (values.artValue) {
            values.art_category = values.artValue;
            delete values.artValue;
          }

          if (values.addressValue) {
            values.province_id = values.addressValue[0];
            values.city_id = values.addressValue[1];
            values.district_id = values.addressValue[2];
            delete values.addressValue;
          }

          // if (values.limit) {
          //   values.limit = values.limit + 1;
          // }
          values.limit = values.limit + 1;
          values.token = this.admin_token;
          this.search_num = values.limit;
          //增加赛事 oc_id
          values.project_id = this.matchId;
          values.oc_id = this.oc_id;

          const result = await ExpertServices.getExpertRandomAsync(values);
          this.expertList = result.data.list;

          this.hasSelected = true;
          this.step = 8;

          setTimeout(() => {
            // var mb = createCanvas({
            //     "target":"random_avatar",
            //     "num":50
            // });
            // mb.run();
          }, 500);
        }
      });
    },
    //结束抽取
    stop() {
      if (!this.showImg) {
        this.form.validateFields(async (err, values) => {
          if (!err) {
            this.hasSelected = false;
            // const result = await ExpertServices.getExpertRandomAsync(values);
            // this.expertList = result.data.list;

            /**  */
            var expertList = this.expertList;
            var result_list = [];
            var max = this.search_num;
            if (max > expertList.length) {
              max = expertList.length;
            }
            expertList.sort(function () {
              return Math.random() - 0.5;
            });
            result_list = expertList.slice(0, max);
            console.log(expertList, result_list);
            this.expertList = result_list;
            /**  */
            this.showImg = true;
            window.scrollTo(0, 500);
            alert("抽取成功，邀请专家成功。");
          }
        });
      }
    },
    //重置
    reset() {
      this.form.resetFields();
      this.hasSelected = false;
      this.showImg = false;
      this.expertList = [];
      this.step = 0;
    },
    //获取赛事
    getMatch(id) {
      getMatch({ id: id }).then((api_res) => {
        if (api_res.code == 200) {
          this.matchList = api_res.data;
        } else {
          alert(api_res.msg);
        }
      });
    },
    getMatchId(id) {
      this.matchId = id;
    },
    useMatch() {
      this.type = 2;
    },
    exportData() {
      exportData({ token: this.admin_token }).then((api_res) => {
        if (api_res.code == 200) {
          window.open('https://api.scwyy.cn/expert.xlsx')
        }
      });
    },
  },
};
</script>


<style lang="less" scoped>
.login {
  > .form {
    width: 500px;
    margin: 50px auto;

    /deep/ .ant-input {
      border: none;
      height: unset;
      background-color: #f6f6f6;
      padding-top: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #989898;
      text-indent: 10px;
    }
    /deep/ .ant-form-item label {
      font-size: 14px;
    }
  }
}
</style>
<style lang="less" scoped>
.random-dom {
  position: relative;
  overflow: hidden;
  background-image: url("/random_bj2.png");
  background-size: 100% 100%;
}

/deep/ .ant-form-item label {
  font-size: 16px;
}

/deep/ .ant-select-selection--single {
  height: 57px;
  background-color: #f6f6f6;
}

/deep/ .ant-select-selection-selected-value {
  padding-left: 10px;
}

/deep/ .ant-upload-list-picture-card-container {
  display: none;
}

/deep/ .ant-form-item label {
  color: #656565;
}
/deep/ .ant-upload.ant-upload-select-picture-card {
  background-color: unset;
  border: none;
}
/deep/ .ant-upload.ant-upload-select-picture-card > .ant-upload {
  padding: 0;
  display: flex;
  align-items: center;
}
/deep/ .ant-upload-picture-card-wrapper {
  width: 135px;
}
/deep/ .ant-input {
  border: none;
  height: unset;
  background-color: #f6f6f6;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 18px;
  color: #989898;
  text-indent: 10px;
}
/deep/ .ant-select-selection--single {
  color: #989898;
  height: unset;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
}

/deep/ .ant-cascader-picker {
  border: 1px solid #e6e7e8;
  width: 240px;
  color: #989898;
  background-color: #f6f6f6;
}

/deep/ .ant-calendar-picker-input.ant-input {
  width: 240px;
  background-color: white;
  border: 1px solid #e6e7e8;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;

  .experts {
    display: flex;
    flex-wrap: wrap;
    li {
      text-align: center;
      width: 18%;
      height: 226px;
      margin-right: 2%;
      position: relative;
      margin-bottom: 18px;
      cursor: pointer;
      img {
        width: 114px;
        height: 156px;
        object-fit: cover;
      }
      div {
        width: 100%;
        height: 20px;
        // position: absolute;
        bottom: 0;
        padding: 10px 0;
        text-align: center;
        // background-color: rgba(0, 0, 0, 0.5);
        color: black;
        font-size: 14px;
      }
    }
  }

  & > .top {
    border-bottom: 2px solid #e6e7e8;
    margin-bottom: 24px;
    margin-top: 40px;
    div {
      width: 120px;
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      padding-bottom: 10px;
      border-bottom: 2px solid #e24141;
    }
  }

  .ant-input {
    border: 1px solid #dddddd;
    height: unset;
    background-color: #ffffff;
    padding-top: 14px;
    padding-bottom: 14px;
    font-size: 18px;
    color: #333333;
    text-indent: 10px;
  }
  .ant-input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #989898;
  }
  .ant-input:focus {
    box-shadow: none;
  }
  .ant-form-item {
    display: flex;
    align-items: center;
  }
  .ant-form-item-label > label {
    font-size: 16px !important;
  }

  .editForm {
    margin: 0 auto;
    width: 600px;
    .eyes {
      width: 20px;
      height: 14px;
      position: absolute;
      right: 0;
      top: 1px;
      right: 18px;
      cursor: pointer;
    }
  }

  .repeatTitle {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;

    .title_text {
      text-align: center;
      background: url("../../assets/images/index/title-line1@2x.png") no-repeat
        40px 0px;
      background-size: contain;
      padding: 10px;
    }

    .art_info_line {
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2left@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        left: -500px;
        top: 34px;
      }

      &::before {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2right@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        right: -500px;
        top: 34px;
      }
    }

    h1 {
      font-size: 26px;
      padding-top: 6px;
    }

    h2 {
      font-size: 14px;
      color: #989898;
      font-weight: normal;
    }
  }

  .joinBtn {
    background: url("../../assets/images/user/bm-bt-submit2@2x.png") no-repeat;
    background-size: 100% 100%;
    width: 240px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    color: #656565;
    margin-left: 200px;
    cursor: pointer;
  }

  .select_choose {
    width: 800px;
    // height: 400px;
    margin: 0 auto;
    display: flex;

    .left {
      width: 320px;
      height: 100%;
      border: 1px solid #dddddd;
      margin-right: 32px;
      border-radius: 8px;
      overflow: hidden;

      .seamless-warp {
        height: 340px;
        overflow: hidden;
        margin: 0 auto;
      }

      .expert_item {
        display: flex;
        align-items: center;
        padding-left: 40px;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        .name {
          margin-right: 20px;
        }
      }
    }
  }

  .btns {
    display: flex;
    justify-content: space-between;
    padding: 0 26px;
    div {
      width: 140px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      cursor: pointer;
    }

    & > :nth-child(1) {
      color: white;
      background: url("../../assets/images/match/bszp-but-01@2x.png") no-repeat;
      background-size: 100% 100%;
    }

    & > :nth-child(2) {
      color: #a32225;
      background: url("../../assets/images/match/bszp-but-02@2x.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>